import React from 'react';
import OrderListPage from './OrderListPage';

interface IProps {
  handleModalOpen: (data: any) => void;
  rowDetails: any;
  setRowDetails: any;
}

const DeliveredOrders = (props: IProps) => (
  <OrderListPage
    section="Order in Delivery"
    emptyMessage="No orders in delivery."
    {...props}
  />
);

export default DeliveredOrders;
